import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e3b1942"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "onboarding-summary16167__more-books"
}

import { computed } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import {
  BookSelection16167Choice,
  Summary16167Page,
} from '@/models/onboarding.types'
import { PublicInterface } from '@/models/interfaces'
import { cacheBust } from '@/models/doc'

import Divider from '@/components/ui/Divider.vue'
import Layout from '../Layout.vue'
import Summary16167Section from '../Summary16167Section.vue'
import Summary16167Choices from '../Summary16167Choices.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Summary16167',
  props: {
    view: null
  },
  setup(__props: any) {

const props = __props as {
  view: PublicInterface<QuestionnaireView>
};



const page = computed(() => {
  return props.view.currentPage as Summary16167Page
})

const whatPreventsYouChoices = computed(() => {
  return props.view.getUserChoice<string[]>('what-prevents-you')
})

const genreChoices = computed(() => {
  return props.view.getUserChoice<string[]>('genre-selection')
})

const bookChoices = computed(() => {
  return props.view.getUserChoice<BookSelection16167Choice>('book-selection')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: "onboarding-summary16167",
    title: _unref(page).title,
    scrollDefaultSlot: true
  }, {
    default: _withCtx(() => [
      (_unref(whatPreventsYouChoices))
        ? (_openBlock(), _createBlock(Summary16167Section, {
            key: 0,
            title: "What stops me from reading more",
            class: "onboarding-summary16167__section onboarding-summary16167__section--what-prevents-you"
          }, {
            default: _withCtx(() => [
              _createVNode(Summary16167Choices, {
                pageID: "what-prevents-you",
                userChoices: _unref(whatPreventsYouChoices),
                view: __props.view
              }, null, 8, ["userChoices", "view"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(whatPreventsYouChoices))
        ? (_openBlock(), _createBlock(Divider, {
            key: 1,
            class: "onboarding-summary16167__divider"
          }))
        : _createCommentVNode("", true),
      (_unref(genreChoices))
        ? (_openBlock(), _createBlock(Summary16167Section, {
            key: 2,
            title: "The main areas I want to improve in",
            class: "onboarding-summary16167__section onboarding-summary16167__section--genres"
          }, {
            default: _withCtx(() => [
              _createVNode(Summary16167Choices, {
                pageID: "genre-selection",
                userChoices: _unref(genreChoices),
                view: __props.view
              }, null, 8, ["userChoices", "view"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(genreChoices))
        ? (_openBlock(), _createBlock(Divider, {
            key: 3,
            class: "onboarding-summary16167__divider"
          }))
        : _createCommentVNode("", true),
      (_unref(bookChoices))
        ? (_openBlock(), _createBlock(Summary16167Section, {
            key: 4,
            title: "Your top books",
            class: "onboarding-summary16167__section onboarding-summary16167__section--books"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookChoices).slice(0, 5), (book, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: book.id,
                  class: "onboarding-summary16167__book"
                }, [
                  _createElementVNode("img", {
                    src: _unref(cacheBust)(book.cover),
                    alt: "",
                    width: "158",
                    height: "211",
                    class: "onboarding-summary16167__cover"
                  }, null, 8, _hoisted_1),
                  (i === 4 && _unref(bookChoices).length > 5)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, " +" + _toDisplayString(_unref(bookChoices).length - 5), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})